import { useRef } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { PlanPricingUsageTable } from '@components/Order/Numbers/Tables';
import { Page500 } from '@containers/ErrorPages';
import { AutoScrollToQuery } from '@features/AutoScrollTo';
import { planDetailsApi } from '@reducers/plan/plan';
import { skipToken } from '@reduxjs/toolkit/query';

export const UsagePricingTab = () => {
  const contentElem = useRef(null);
  const { showState } = useSelector((state) => state.plan.planInfo);
  const queryArg =
    showState.currentPlan.id && showState.currentPlan.type
      ? { ...showState.currentPlan }
      : skipToken;
  const pricingQuery = planDetailsApi.useGetPricingQuery(queryArg);

  if (pricingQuery.isLoading || pricingQuery.isFetching) {
    return (
      <div ref={contentElem}>
        <DefaultSpinnerCenter />
        <AutoScrollToQuery query={pricingQuery} ref={contentElem} />
      </div>
    );
  }
  if (pricingQuery.isError) {
    return <Page500 />;
  }
  return (
    <div ref={contentElem}>
      <Row>
        <Col md={8}>
          <PlanPricingUsageTable data={[pricingQuery.data.usage]} />
        </Col>
      </Row>
      <AutoScrollToQuery query={pricingQuery} ref={contentElem} />
    </div>
  );
};
